import { getZtCoreVersion } from '../../lib/libs'
// import { trace } from '../../lib/trace'
class Flutter {
  appInfo = {}
  namespace = {
    closeWindow: 'onWindowClose'
  }
  support = {
    preloadWindow: getZtCoreVersion() >= 15,
    clearPreloadWindowById: getZtCoreVersion() >= 15,
    openWindow: getZtCoreVersion() >= 15,
    openCommonWindow: getZtCoreVersion() >= 15,
    closeWindow: getZtCoreVersion() >= 15,
    postMessage: getZtCoreVersion() >= 15,
    addEventListener: getZtCoreVersion() >= 15,
    removeEventListener: getZtCoreVersion() >= 15,
    addWindowCloseListener: getZtCoreVersion() >= 15,
    removeWindowCloseListener: getZtCoreVersion() >= 15
  }
  /**
   * flutter event 广播事件列表
   */
  eventMaps = new Map()
  constructor() {
    window.addEventListener('message', (event) => {
      if (typeof event.data === 'string') {
        if (event.data.includes('flutterMessage')) {
          console.log('flutterMessage', event.data)
          try {
            const eventData = JSON.parse(event.data)
            /* 全局事件 */
            if (eventData.event === 'windowEvent') {
              const { name, data } = eventData.data
              console.log('---data', data)
              this.eventMaps.get(name) && this.eventMaps.get(name)(data)
            }
            if (eventData.event === 'closeWindow') {
              console.log('eventData.windowId', eventData.windowId)
              this.eventMaps.get(`${this.namespace.closeWindow}_${eventData.windowId}`) &&
                this.eventMaps.get(`${this.namespace.closeWindow}_${eventData.windowId}`)()
            }
          } catch (error) {
            console.error('Flutter event 广播异常', error)
          }
        }
      }
    })
  }
  // 预加载窗口
  preloadWindow(data) {
    return new Promise((resolve, reject) => {
      const params = {
        url: data.url,
        windowName: data.title,
        header: data.header,
        barBgColor: data.barBgColor,
        brightness: data.brightness,
        isCheckNet: data.isCheckNet,
        appBoundDomains: data.appBoundDomains
      }
      console.log('===> preloadWindow ~ params', params)
      window.flutter_inappwebview.callHandler('preloadWindow', JSON.stringify(params)).then((data) => {
        console.log('preloadWindowSuccess', data.data)
        resolve(data.data.windowId)
      })
    })
  }

  // 清除预加载window
  clearPreloadWindowById(id) {
    return window.flutter_inappwebview.callHandler('clearPreloadWindowById', JSON.stringify(id ? { windowId: id } : {}))
  }

  /**
   * 打开一个新窗口
   * @param {*} data
   * @returns
   */
  openWindow(data) {
    return new Promise((resolve, reject) => {
      const params = {
        url: data.url,
        windowName: data.title,
        windowId: data.windowId,
        titleColor: '#000',
        color: '#fff',
        header: data.header,
        barBgColor: data.barBgColor,
        brightness: data.brightness,
        isCheckNet: data.isCheckNet,
        appBoundDomains: data.appBoundDomains,
        ua: data.ua
      }
      console.log('openWindow', params)
      window.flutter_inappwebview.callHandler('openWindow', JSON.stringify(params)).then((data) => {
        console.log('openWindowSuccess', data.data.windowId)
        resolve(data.data.windowId)
      })
    })
  }
  // 打开通用窗口 openCommonWindow
  openCommonWindow(data) {
    return new Promise((resolve, reject) => {
      const params = {
        url: data.url,
        title: data.title,
        header: data.header
      }
      console.log('openCommonWindow', params)
      window.flutter_inappwebview.callHandler('openCommonWindow', JSON.stringify(params)).then((data) => {
        resolve(data)
      })
    })
  }

  /**
   * 关闭一个window窗口, 不传则关闭当前window,传 0 则关闭所有window,传 win  则页面栈关闭到指定window
   * @param { string } id
   */
  closeWindow = (id) => {
    return window.flutter_inappwebview.callHandler('closeWindow', JSON.stringify(id ? { windowId: id } : {}))
  }

  /**
   * 发送消息
   * @param {string} name 消息名称
   * @param {Object} data 消息内容
   */
  postMessage = (name, data) => {
    console.log('postmsg', name, data)
    window.flutter_inappwebview.callHandler(
      'windowEvent',
      JSON.stringify({
        name,
        data
      })
    )
  }
  /**
   * 接收消息
   * @param {string} name 消息名称
   * @param {Function} callback 回调函数，回调函数参数为消息内容
   */
  addEventListener = (name, callback = () => {}) => {
    this.eventMaps.set(name, callback)
  }
  /**
   * 移除消息监听
   * @param {string} name 消息名称
   */
  removeEventListener = (name) => {
    console.log('removeEventListener', name)
    this.eventMaps.delete(name)
  }

  /**
   * 关闭对应windowId页面时触发,只触发一次就会自动销毁
   * @param {string} id 页面id
   */
  addWindowCloseListener = (id, callback) => {
    this.addEventListener(`${this.namespace.closeWindow}_${id}`, () => {
      this.removeWindowCloseListener(id)
      if (callback) {
        callback()
      }
    })
  }
  /**
   * 移除关闭页面监听
   * @param {string} id 页面id
   */
  removeWindowCloseListener = (id) => {
    this.removeEventListener(`${this.namespace.closeWindow}_${id}`)
  }
}

export default new Flutter()
